// @ts-nocheck
import { $uniUP } from "../.."
import { IUniConfig } from "../../../uni-base/uni-base-module"

function SidebarForm($http, $timeout, $log, UniConfig: IUniConfig) {
  return {
    restrict: "E",
    scope: {
      visible: "=",
      title: "@",
      open: "@"
    },
    // controllerAs : 'gestionCtrl',
    // templateUrl : baseUrl + '/app/templates/vigilancia/progTrabajadoresModal.html',
    transclude: true,
    template: require("./sidebar-form.inline.html"),
    link: function(scope, element, attrs, ctrls) {
      $log.debug("Instanciando sidebarform", scope)

      scope.$watch(
        function() {
          return scope.visible
        },
        function(val) {
          $log.debug("Cambio visible ", val)

          if (val) $("body").addClass("opened")
          else $("body").removeClass("opened")
        }
      )

      scope.cerrarSidebarForm = () => {
        scope.visible = false
      }
    }
  }
}

SidebarForm.$inject = ["$http", "$timeout", "$log", "UniConfig"]

$uniUP.directive("upSidebarForm", SidebarForm)
